// extracted by mini-css-extract-plugin
export var askAiIcon = "_k5-9";
export var container = "_k5-0";
export var groupSeparator = "_k5-a";
export var highlight = "_k5-4";
export var resultIcon = "_k5-5";
export var resultItem = "_k5-7";
export var resultSubtitle = "_k5-3";
export var resultTitle = "_k5-2";
export var resultsList = "_k5-1";
export var searchGroup = "_k5-6";
export var selected = "_k5-8";